import DifferenceIcon from '@mui/icons-material/Difference';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import { Office } from '../../models/office';
import { ContactsCount } from '../contacts/contacts-count-grid-cell';
import { ContractsCount } from '../contracts/contracts-count-grid-cell';
import { GridCountCell } from '../../components/grid-cell-count';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface CustomGridCellProps {
  field: string;
}

interface CellProps {
  office: Office;
}

const styling = {
  iconStyle: { color: '$primary-color' },
  textStyle: { paddingLeft: '5px', color: '$primary-color' },
};
const ContactsCountCell = ({ office }: CellProps) => {
  return <ContactsCount count={office.contactsCount} customerID={office.customerID} officeID={office.officeID} />;
};

const ContractsCountCell = ({ office }: CellProps) => {
  return <ContractsCount count={office.contractsCount} officeID={office.officeID} />;
};

const ProjectsCountCell = ({ office }: CellProps) => {
  const isProjectViewPermission = useAuthorize([UserPermissionName.VIEW_PROJECT]);
  return (
    <GridCountCell
      count={office.projectsCount}
      icon={<DifferenceIcon style={styling.iconStyle} />}
      route={`/projects?customerID=${office.customerID}&officeID=${office.officeID}`}
      isDisabled={!isProjectViewPermission}
    />
  );
};

const UnitsCountCell = ({ office }: CellProps) => {
  const isUnitViewPermission = useAuthorize([UserPermissionName.VIEW_UNIT]);
  return (
    <GridCountCell
      count={office.lotsCount}
      icon={<HomeWorkOutlinedIcon style={styling.iconStyle} />}
      route={`/units?customerID=${office.customerID}&officeID=${office.officeID}`}
      isDisabled={!isUnitViewPermission}
    />
  );
};

export const OfficeCustomGridCell = ({ field }: CustomGridCellProps) => {
  if (field === 'projects') {
    return (dataItem: any) => {
      return <ProjectsCountCell office={dataItem.dataItem} />;
    };
  }
  if (field === 'contacts') {
    return (dataItem: any) => {
      return <ContactsCountCell office={dataItem.dataItem} />;
    };
  }
  if (field === 'contracts') {
    return (dataItem: any) => {
      return <ContractsCountCell office={dataItem.dataItem} />;
    };
  }
  if (field === 'lots') {
    return (dataItem: any) => {
      return <UnitsCountCell office={dataItem.dataItem} />;
    };
  }
};
